import { FunctionComponent, useEffect, useState } from 'react'
import styles from './groupPSU.module.scss'
import { useTranslation } from 'react-i18next'
import { DaycareGroup } from '@/types/DaycareGroup'
import { useMutation } from '@apollo/client'
import { SET_DAYCARE_GROUP_PSU } from '@/modules/API/daycareGroup/daycareGroupUrl'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'

interface GroupPSUProps {
    group?: DaycareGroup
    canWrite: boolean
    refetchGroups: () => void
}

const GroupPSU: FunctionComponent<GroupPSUProps> = ({ group, canWrite, refetchGroups }: GroupPSUProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [daycarePSU, setDaycarePSU] = useState<string>(group?.daycarePSU.toString() || '6')

    const [setDaycareGroupDaycarePSU, { loading: loadingPSU }] = useMutation(SET_DAYCARE_GROUP_PSU, {
        variables: {
            groupId: group?.id,
            daycarePSU: parseFloat(daycarePSU)
        },
        onCompleted: () => {
            refetchGroups()
            showNotificationSuccess(t('daycarePSUUpdated'))
        },
        onError: () => {
            showNotificationError(t('errorUpdatedDaycarePSU'))
        }
    })

    useEffect(() => {
        setDaycarePSU(group?.daycarePSU.toString() || '6')
    }, [group])

    return (
        <div className={styles.Container}>
            <div className={styles.TitleAndButton}>
                <div className={styles.Title}>
                    <p>{t('yourPSU')}</p>
                </div>
            </div>
            {group && (
                <div className={styles.InfoContainer}>
                    <UserInput
                        label={'PSU'}
                        value={daycarePSU}
                        setValue={setDaycarePSU}
                        type={'number'}
                        minNumber={0}
                        maxNumber={100}
                        format={'float'}
                        step={0.5}
                        endAdornment={'€/Heure'}
                        className={styles.Input}
                    />
                    {canWrite && (
                        <ButtonTextIcon
                            type={'update'}
                            onClick={setDaycareGroupDaycarePSU}
                            className={styles.Button}
                            disabled={loadingPSU || daycarePSU === group?.daycarePSU.toString()}
                        />
                    )}
                </div>
            )}
        </div>
    )
}

export default GroupPSU
